<template>
  <div>
    <bm-text
      :value="value"
      :rules="computedRules"
      v-bind="$attrs"
      autofocus
      data-qa="scan_item_manual_input"
      clearable
      @keydown="$emit('keydown', $event)"
      @input="$emit('input', $event)"
    >
      <template #append-outer>
        <slot name="append-outer" />
      </template>
    </bm-text>
    <slot name="action" />
  </div>
</template>

<script lang="ts">
import BmText from "@/components/controls/input/BmText.vue";
import type { ValidationRule } from "@/app/services/modelObject";
import type { PropType } from "vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BmBarcodeTextInput",
  components: { BmText },
  props: {
    value: {
      type: String,
      default: "",
    },
    computedRules: {
      type: Array as PropType<ValidationRule[]>,
      default: () => [],
    },
  },
});
</script>
